import React from "react";

import ExpenseCardWarningText from "../ExpenseCardWarningText/ExpenseCardWarningText";
import FilledCard from "@src/multiCustodian/components/FinancialPlans/CreateUpdatePlanFlow/pages/Shared/FilledCard/FilledCard";

interface Props {
  heading: string;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
  title: string;
  titleRight: string;
  text: string;
  hasAccounts: boolean;
}
const FilledExpenseCard: React.FC<Props> = ({
  heading,
  onClick,
  title,
  text,
  titleRight,
  hasAccounts,
}) => {
  const titleRightContent = hasAccounts ? (
    titleRight
  ) : (
    <ExpenseCardWarningText text="Select an account" />
  );
  return (
    <FilledCard
      onClick={onClick}
      heading={heading}
      titleRight={titleRightContent}
      text={text}
      title={title}
    />
  );
};

export default FilledExpenseCard;
